import React from 'react';
import { Box, Typography } from '@mui/material';

/** Compact per-attempt or aggregate question breakdown (Total / Correct / Partial / Incorrect / Unattended). */
export default function MockExamQuestionStatsBlock({ stats, title = 'Questions' }) {
  if (!stats || typeof stats.total_questions !== 'number') {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }
  const {
    total_questions: total = 0,
    correct = 0,
    partially_correct: partial = 0,
    incorrect = 0,
    unattended = 0,
  } = stats;
  const line = (label, value, color) => (
    <Typography key={label} variant="body2" sx={{ color, fontWeight: 600, lineHeight: 1.55 }}>
      {label}: {value}
    </Typography>
  );
  return (
    <Box sx={{ py: 0.25, minWidth: 148 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.25, color: '#0f172a' }}>
        {title}
      </Typography>
      {line('Total', total, '#334155')}
      {line('Correct', correct, '#0d9488')}
      {line('Partially correct', partial, '#c2410c')}
      {line('Incorrect', incorrect, '#dc2626')}
      {line('Unattended', unattended, '#374151')}
    </Box>
  );
}
